
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { Controlador as Model, ControladorDeCurso } from '../../controlador-crear-curso';
    import videos from './cursos-crear-recursos-editar.vue';
    import { Recurso } from '@/__env/lib/Cursos/Recursos';
    import { Wait } from '@/__env/ext';
    import { clearLine } from 'readline';
    import { Curso } from '@/__env/lib/Cursos';
    @Component( {
        name: "Componente",
        props: {},
        components: {
            videos,
        }
    } )
    export default class Componente extends Vue
    {
        @Prop()
        public ReadOnly: boolean;

        public get Controlador(): ControladorDeCurso { return Model; }

        @Prop()
        public Curso: Curso;


        public SeleccionarArchivo: boolean = false;;
        public SubiendoArchivo: boolean = false;;
        public SeleccionarVideo: boolean = false;;


        public async AgregarArchivo( archivo: any )
        {
            if ( !archivo )
                return;
            this.SubiendoArchivo = true;
            await Wait( 1000 );
            let ar = await Recurso.subirArchivo( archivo );
            if ( ar )
            {
                let r = new Recurso();
                r.Nombre = archivo.name;
                r.Tipo = archivo.type.includes( 'image' ) ? 'imagen' : 'archivo';
                r.Recurso = ar;
                this.Curso.Recursos.push( r );
            } else
            {
                this.$EventBus.Notificaciones.Error( 'Error al subir el archivo' );
            }



            this.SubiendoArchivo = false;
            this.$emit( 'agregar', this.Curso.Recursos );
        }

        public AgregarVideo( video: { Nombre: string, URL: string; } )
        {
            let r = new Recurso();
            r.Nombre = video.Nombre;
            r.Tipo = 'video';
            r.Recurso = video.URL;
            this.Curso.Recursos.push( r );

            this.Controlador.$emit( 'change' );
        }

        public Eliminar( index: number )
        {
            this.Curso.Recursos.splice( index, 1 );
            this.Controlador.$emit( 'change' );
        }

        public Abrir( link: string )
        {
            window.open( link );
        }
    }
